import type { Stage } from '@crm/shared';
import { Link } from 'react-router-dom';

import type { Opportunity } from '../../lib/api';
import { formatBps, formatChf } from '../../lib/format';

const STAGE_LABEL: Record<Stage, string> = {
  identified: 'Identified',
  qualifying: 'Qualifying',
  compliance_review: 'Compliance review',
  proposal: 'Proposal',
  onboarding: 'Onboarding',
  active: 'Active',
};

/**
 * Compact one-line-per-opportunity reading mode. Used as the third tab next
 * to Kanban and Table — best for skimming on mobile or in side-by-side views.
 */
export function PipelineList({ opportunities }: { opportunities: Opportunity[] }) {
  return (
    <div className="px-8 pb-10">
      <ul className="card divide-y divide-platinum">
        {opportunities.map((o) => (
          <li
            key={o.id}
            className="px-5 py-3 flex items-center gap-4 hover:bg-glacier/40 transition-colors"
          >
            <Link
              to={`/opportunities/${o.id}`}
              className="flex-1 min-w-0 truncate font-medium text-ink hover:text-graphite"
              title={o.name}
            >
              {o.name}
            </Link>
            <span className="text-xs uppercase tracking-wider text-ink-tertiary w-32 shrink-0">
              {STAGE_LABEL[o.stage]}
            </span>
            <span className="font-tabular text-sm text-ink-secondary w-20 text-right shrink-0">
              {formatBps(o.roa_bps)}
            </span>
            <span className="font-tabular text-sm text-ink w-32 text-right shrink-0">
              {formatChf(o.initial_expected_amount)}
            </span>
            <span className="font-tabular text-sm text-ink font-medium w-32 text-right shrink-0">
              {formatChf(o.score_chf)}
            </span>
          </li>
        ))}
        {opportunities.length === 0 && (
          <li className="px-5 py-12 text-center text-sm italic text-ink-tertiary">
            No opportunities.
          </li>
        )}
      </ul>
    </div>
  );
}
